
import Size from '../../enums/Size';
import Spinner from './Spinner';
import { Button } from 'react-aria-components';

export interface ISubmitButton {
  isLoading: boolean
  isDisabled: boolean,
  submittingText?: string | undefined,
  idleText?: string | undefined,
  size?: Size | undefined
}

const SubmitButton = ({ isLoading, isDisabled, submittingText, idleText, size }: ISubmitButton) => {

  function getButtonSizeModifier(): Size {
    return size ?? ('large' as unknown as Size);
  }

  return (
    <Button type="submit" className={`button button--primary button--${getButtonSizeModifier()}`} isDisabled={isDisabled}>
      {isLoading ?
        <div className='spinner__wrapper'>
          <Spinner />
          <p className="button-text">{submittingText ?? 'Saving'}</p>
        </div> :
        <p className="button-text">{idleText ?? 'Save'}</p>
      }
    </Button>
  );
};

export default SubmitButton;